module.exports = __webpack_public_path__ + "static/media/pink-october.73913660.jpg";